import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import {
  IUseUpdateMutation,
  IUpdateFn,
  ITrainingPersonSeparateUpsert,
  ITrainingPerson,
  IGetPutRequest,
} from '../../interfaces'

const getSeparateTrainingPersonMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/People/`,
})

const useSeparateTrainingPersonMutation: IUseUpdateMutation<ITrainingPerson, ITrainingPersonSeparateUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getSeparateTrainingPersonMutationRequest(params), [params])

  const separateTrainingPerson: IUpdateFn<ITrainingPersonSeparateUpsert, ITrainingPerson> = useCallback(
    async data => axios({ ...request, url: request.url + data.id + '/separate', data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingPerson, Error, any>({
    mutationFn: separateTrainingPerson,
    ...options,
  })

  return response
}

export default useSeparateTrainingPersonMutation
